import { useSuspenseQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { useGoodsSno } from '../../../../../hooks/useGoodsSno';
import { queryKey } from '../../../../../constant/queryKey';

export const useSizeReviewAnalysis = () => {
  const sno = useGoodsSno();
  return useSuspenseQuery({
    queryKey: queryKey.sizeReviewAnalysis(sno),
    queryFn: () => goodsService.getSizeReviewAnalysis(sno),
  });
};
